<template>
  <div class="lettura-view">
    <Loader v-if="loading"></Loader>
    <div class="lv-page-wrapper">
      <div class="lv-page-container">
        <div class="lv-header">
          <h3 class="lv-title">Situazione Flussi</h3>
        </div>
        <div class="lv-switch-container">
          <div class="lv-switch-wrapper">
            <span class="lv-switch-label" :class="{ 'lv-switch-label--active': selectedType === 'EE' }"
              @click="changeType('EE')">EE</span>
            <label class="lv-switch">
              <input type="checkbox" :checked="selectedType === 'GAS'" @change="toggleType">
              <span class="lv-switch-slider"></span>
            </label>
            <span class="lv-switch-label" :class="{ 'lv-switch-label--active': selectedType === 'GAS' }"
              @click="changeType('GAS')">GAS</span>
          </div>
        </div>
        <div class="lv-filter-section">
          <div class="lv-date-selectors">
            <div class="lv-selector-group">
              <label>Periodo Competenza:</label>
              <div class="lv-date-inputs">
                <select v-model="selectedMonth" class="lv-select" @change="filterData">
                  <option v-for="(month, index) in months" :key="index" :value="index">{{ month }}</option>
                </select>
                <select v-model="selectedYear" class="lv-select" @change="filterData">
                  <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="lv-calendar-container">
            <label>Statistiche del giorno:</label>
            <div class="lv-calendar-picker">
              <div class="lv-selected-date" @click="toggleCalendar">
                {{ selectedDay }} {{ months[new Date().getMonth()].substring(0, 3) }}
              </div>

              <div v-if="showCalendar" class="lv-calendar-popup">
                <div class="lv-calendar-header">
                  <div>{{ months[new Date().getMonth()] }} {{ new Date().getFullYear() }}</div>
                  <div class="lv-calendar-close" @click="toggleCalendar">×</div>
                </div>

                <div class="lv-weekdays">
                  <div v-for="day in weekdays" :key="day" class="lv-weekday">{{ day }}</div>
                </div>

                <div class="lv-calendar-days">
                  <div v-for="i in firstDayOfMonth" :key="`empty-${i}`" class="lv-day lv-day--empty"></div>
                  <div v-for="day in daysInMonth" :key="day" class="lv-day"
                    :class="{ 'lv-day--selected': day === selectedDay, 'lv-day--today': isToday(day) }"
                    @click="selectDay(day)">
                    {{ day }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="lv-table-section" v-if="distribuzioneData.length > 0">
          <div class="lv-date-display" v-if="selectedDay">
            Dati per: <span class="lv-date-value">{{ formatSelectedDate() }}</span>
            <span class="lv-type-indicator"> - {{ selectedType }}</span>
          </div>

          <PrimeDataTable :value="distribuzioneData" dataKey="id" filterDisplay="menu" class="lv-data-table"
            :loading="loading" responsiveLayout="scroll">
            <PrimeColumn field="ragsoc" header="Fornitore" style="min-width: 15rem;">
              <template #body="slotProps">
                <span :class="{ 'lv-totale-row': slotProps.data.ragsoc.toLowerCase() === 'totale' }">{{
                  slotProps.data.ragsoc }}</span>
              </template>
            </PrimeColumn>
            <PrimeColumn field="quantita" header="Numero Flussi"  style="min-width: 12rem">
              <template #body="slotProps">
                <span :class="{ 'lv-totale-row': slotProps.data.ragsoc.toLowerCase() === 'totale' }">{{
                  slotProps.data.quantita }}</span>
              </template>
            </PrimeColumn>
            <PrimeColumn :field="quantitaField" :header="quantitaHeader"  style="min-width: 12rem">
              <template #body="slotProps">
                <span :class="{ 'lv-totale-row': slotProps.data.ragsoc.toLowerCase() === 'totale' }">
                  {{ slotProps.data[quantitaField] }}
                </span>
              </template>
            </PrimeColumn>
            <PrimeColumn field="quantita_utili" header="Numero Flussi Fine Mese"  style="min-width: 12rem">
              <template #body="slotProps">
                <span :class="{ 'lv-totale-row': slotProps.data.ragsoc.toLowerCase() === 'totale' }">{{
                  slotProps.data.quantita_utili }}</span>
              </template>
            </PrimeColumn>
            <PrimeColumn field="quantita_letture" header="Numero Mensilità Reali" style="min-width: 12rem">
              <template #body="slotProps">
                <span :class="{ 'lv-totale-row': slotProps.data.ragsoc.toLowerCase() === 'totale' }">{{
                  slotProps.data.quantita_letture }}</span>
              </template>
            </PrimeColumn>
          </PrimeDataTable>
        </div>

        <div v-else-if="!loading" class="lv-empty-state">
          <div class="lv-empty-icon">📊</div>
          <h3>Nessun dato disponibile</h3>
          <p>Non ci sono dati disponibili per il periodo selezionato ({{ selectedType }}).</p>
        </div>

        <div v-if="error" class="lv-error-alert">
          <div class="lv-error-message">{{ error }}</div>
        </div>

        <!-- Upload File -->
        <div class="lv-card-wrapper">
          <Card class="lv-card">
            <template v-slot:content>
              <h1 class="lv-card-title">Caricamento Letture</h1>

              <div class="lv-upload-zone" :class="{ 'lv-upload-zone--dragover': isDragging }"
                @dragover.prevent="onDragOver" @dragleave.prevent="onDragLeave" @drop.prevent="onDrop">
                <input id="upload" type="file" ref="file" @change="handleFileUpload($event)"
                  :accept="acceptedFileTypes" multiple
                  class="lv-file-input" />

                <div class="lv-upload-icon">📁</div>
                <div class="lv-upload-text">Trascina i file qui o clicca per selezionare</div>
                <div class="lv-upload-subtext">Formati consentiti: {{ allowedType.join(", ") }}</div>

                <div v-if="fileToUpload.length > 0" class="lv-file-list">
                  <div v-for="(file, index) in fileToUpload" :key="index" class="lv-file-item">
                    <div>
                      <span class="lv-file-name">{{ file.name }}</span>
                      <span class="lv-file-size">({{ formatFileSize(file.size) }})</span>
                    </div>
                    <button @click="removeFile(index)" class="lv-file-remove">×</button>
                  </div>
                </div>
              </div>

              <div v-show="validationErrors.files && submitted" class="lv-error-text">Campo richiesto.</div>
              <div v-show="validationErrors.type && submitted" class="lv-error-text">Formato non consentito</div>

              <div class="lv-button-group">
                <Button @click="uploadFileLettureOnFtp" label="Carica File EE" class="lv-btn lv-btn--primary" />
                <Button @click="uploadFileLettureOnFtpGas" label="Carica File Gas" class="lv-btn lv-btn--success" />
              </div>
            </template>
          </Card>
        </div>

        <div class="lv-card-wrapper">
          <Card class="lv-card lv-card--wide">
            <template v-slot:header>
              <h3 class="lv-card-title">Storico File Caricati {{ selectedType }}</h3>
              <div class="lv-switch-container">
                <div class="lv-switch-wrapper">
                  <span class="lv-switch-label" :class="{ 'lv-switch-label--active': selectedType === 'EE' }"
                    @click="changeType('EE')">EE</span>
                  <label class="lv-switch">
                    <input type="checkbox" :checked="selectedType === 'GAS'" @change="toggleType">
                    <span class="lv-switch-slider"></span>
                  </label>
                  <span class="lv-switch-label" :class="{ 'lv-switch-label--active': selectedType === 'GAS' }"
                    @click="changeType('GAS')">GAS</span>
                </div>
              </div>
            </template>

            <template v-slot:content>
              <div>
                <input type="text" v-model="searchQuery" placeholder="Cerca file..." class="lv-search-input" />
              </div>
              <table class="lv-table">
                <thead class="lv-table-head">
                  <tr>
                    <th class="lv-table-th">File</th>
                    <th class="lv-table-th">Data di caricamento</th>
                    <th class="lv-table-th">Utente</th>
                  </tr>
                </thead>
                <tbody class="lv-table-body">
                  <tr v-for="file in filteredFiles" :key="file.file_name" class="lv-table-tr">
                    <td class="lv-table-td">{{ file.file_name }}</td>
                    <td class="lv-table-td">{{ file.created_at }}</td>
                    <td class="lv-table-td">{{ file.email }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="lv-select-wrapper">
                <select id="fileCount" v-model="filesPerPage" class="lv-select lv-select--small">
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            </template>
          </Card>
        </div>

        <div class="lv-card-wrapper">
          <Card class="lv-card lv-card--wide">
            <template v-slot:header>
              <h3 class="lv-card-title">Logs {{ selectedType }}</h3>
            </template>

            <template v-slot:content>
              <table class="lv-table" v-if="!logsLoading">
                <thead class="lv-table-head">
                  <tr>
                    <th class="lv-table-th">File</th>
                    <th class="lv-table-th">Status</th>
                    <th class="lv-table-th">Data</th>
                    <th class="lv-table-th">Messaggio</th>
                  </tr>
                </thead>
                <tbody class="lv-table-body">
                  <tr v-for="log in currentLogs" :key="log.id" class="lv-table-tr">
                    <td class="lv-table-td">{{ log.file_name }}</td>
                    <td class="lv-table-td">{{ log.status }}</td>
                    <td class="lv-table-td">{{ log.created_at }}</td>
                    <td class="lv-table-td">{{ log.message }}</td>
                  </tr>
                </tbody>
              </table>
              <div v-else class="lv-loading">Caricamento logs...</div>

              <div class="lv-pagination" v-if="totalLogs > perPageLogs">
                <button @click="onPageChangeLogs(currentPageLogs - 1)" :disabled="currentPageLogs === 1"
                  class="lv-btn lv-btn--secondary">Precedente</button>
                <span class="lv-pagination-info">Pagina {{ currentPageLogs }} di {{ Math.ceil(totalLogs /
                  perPageLogs) }}</span>
                <button @click="onPageChangeLogs(currentPageLogs + 1)"
                  :disabled="currentPageLogs >= Math.ceil(totalLogs / perPageLogs)"
                  class="lv-btn lv-btn--secondary">Successiva</button>
              </div>
            </template>
          </Card>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, getCurrentInstance, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from 'vue-router';
import Service from "@/services/ask-caricamento-file/caricamento-file";
import LettureService from "../../../services/ask-letture/letture-service.js";
import Loader from "@/components/Loader.vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";
import axios from "axios";
import Button from 'primevue/button';
import Card from 'primevue/card';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import 'primeicons/primeicons.css';

export default {
  name: 'LetturaView',
  components: {
    Loader,
    Button,
    Card,
    PrimeDataTable: DataTable,
    PrimeColumn: Column
  },

  setup() {
    const store = useStore();
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const caricamentoService = new Service(self.$eventBus);
    const lettureService = new LettureService(self.$eventBus);
    const router = useRouter();

    const fileToUpload = ref([]);
    const validationErrors = ref({});
    const submitted = ref(false);
    const loading = ref(true);
    const uploadedFiles = ref([]);
    const uploadedFilesCount = ref(0);
    const currentPage = ref(1);
    const filesPerPage = ref(10);
    const searchQuery = ref("");
    const processedFiles = ref([]);
    const isDragging = ref(false);

    const distribuzioneData = ref([]);
    const error = ref(null);
    const showCalendar = ref(false);
    const selectedType = ref('EE');
    const currentLogs = ref([]);
    const logsLoading = ref(false);
    const currentPageLogs = ref(1);
    const perPageLogs = ref(10);
    const totalLogs = ref(0);

    const currentDate = new Date();
    const previousMonth = currentDate.getMonth() === 0 ? 11 : currentDate.getMonth() - 1;
    const previousMonthYear = currentDate.getMonth() === 0 ? currentDate.getFullYear() - 1 : currentDate.getFullYear();

    const selectedMonth = ref(previousMonth);
    const selectedYear = ref(previousMonthYear);
    const selectedDay = ref(currentDate.getDate());

    const allowedType = computed(() => {
      if (selectedType.value === 'GAS') {
        return ['zip', 'x-zip-compressed', 'xml', 'xlsx'];
      }

      return ['zip', 'x-zip-compressed', 'xml'];
    });

    const acceptedFileTypes = computed(() => {
      if (selectedType.value === 'GAS') {
        return '.zip,.xml,.xlsx,application/zip,application/x-zip-compressed,application/xml,text/xml,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      }

      return '.zip,.xml,application/zip,application/x-zip-compressed,application/xml,text/xml';
    });

    const formattedMesecomp = computed(() => {
      let month = selectedMonth.value + 1;
      return `${selectedYear.value}-${month < 10 ? '0' + month : month}`;
    });

    const formattedCreationday = computed(() => {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const day = selectedDay.value;
      return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
    });

    const weekdays = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];

    const months = [
      'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
      'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
    ];

    const years = [];
    for (let year = 2020; year <= currentDate.getFullYear(); year++) {
      years.push(year);
    }

    const quantitaHeader = computed(() => {
      return selectedType.value === 'EE' ? 'Quantità POD' : 'Quantità PDR';
    });

    const quantitaField = computed(() => {
      return selectedType.value === 'EE' ? 'quantita_pod' : 'quantita_pdr';
    });

    const toggleType = () => {
      selectedType.value = selectedType.value === 'EE' ? 'GAS' : 'EE';
      console.log('toggleType:', selectedType.value);
      fetchData();
      fetchCurrentTypeLogs();
      fetchUploadedFiles();
    };

    const changeType = (type) => {
      console.log('changeType called with:', type);
      selectedType.value = type;
      console.log('selectedType set to:', selectedType.value);
      fetchData();
      fetchCurrentTypeLogs();
      fetchUploadedFiles();
    };

    const fetchCurrentTypeLogs = async () => {
      logsLoading.value = true;
      console.log('fetchCurrentTypeLogs called with selectedType:', selectedType.value);

      try {
        let response;

        if (selectedType.value === 'EE') {
          response = await lettureService.getFileLettureEELogs(currentPageLogs.value, perPageLogs.value);
        } else {
          response = await lettureService.getFileLettureGasLogs(currentPageLogs.value, perPageLogs.value);
        }

        if (response && response.data) {
          currentLogs.value = response.data;
          totalLogs.value = response.total || 0;
        } else {
          currentLogs.value = [];
          totalLogs.value = 0;
        }

        console.log('Logs received:', currentLogs.value);
      } catch (error) {
        console.error("Errore log:", error);
        toast.add({ severity: "error", summary: "Errore", detail: "Errore caricamento logs" });
        currentLogs.value = [];
      } finally {
        logsLoading.value = false;
      }
    };

    const onPageChangeLogs = (page) => {
      currentPageLogs.value = page;
      fetchCurrentTypeLogs();
    };

    const toggleCalendar = () => {
      showCalendar.value = !showCalendar.value;
    };

    const firstDayOfMonth = computed(() => {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      let day = date.getDay();
      day = day === 0 ? 6 : day - 1;
      return day;
    });

    const daysInMonth = computed(() => {
      return new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
    });

    const isToday = (day) => {
      const today = new Date();
      return (
        day === today.getDate() &&
        today.getMonth() === currentDate.getMonth() &&
        today.getFullYear() === currentDate.getFullYear()
      );
    };

    const formatSelectedDate = () => {
      return new Intl.DateTimeFormat('it-IT', { day: '2-digit', month: 'long', year: 'numeric' }).format(
        new Date(currentDate.getFullYear(), currentDate.getMonth(), selectedDay.value)
      );
    };

    const selectDay = (day) => {
      selectedDay.value = day;
      showCalendar.value = false;
      fetchData();
    };

    const onDragOver = (e) => {
      e.preventDefault();
      isDragging.value = true;
    };

    const onDragLeave = (e) => {
      e.preventDefault();
      isDragging.value = false;
    };

    const onDrop = (e) => {
      e.preventDefault();
      isDragging.value = false;
      submitted.value = false;

      const files = Array.from(e.dataTransfer.files);
      const validFiles = [];
      const maxSize = 500000 * 1024;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (file.size <= maxSize) {
          validFiles.push(file);
        } else {
          toast.add({ severity: "error", summary: "Errore", detail: `Il file ${file.name} supera 500MB` });
        }
      }

      fileToUpload.value = validFiles;
    };

    const removeFile = (index) => {
      fileToUpload.value.splice(index, 1);
    };

    const formatFileSize = (size) => {
      const units = ['B', 'KB', 'MB', 'GB'];
      let i = 0;

      while (size >= 1024 && i < units.length - 1) {
        size /= 1024;
        i++;
      }

      return `${size.toFixed(1)} ${units[i]}`;
    };

    const handleFileUpload = (evt) => {
      evt.preventDefault();
      submitted.value = false;

      const files = self.refs.file.files;
      const validFiles = [];
      const maxSize = 500000 * 1024;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (file.size <= maxSize) {
          validFiles.push(file);
        } else {
          toast.add({ severity: "error", summary: "Errore", detail: `Il file ${file.name} supera 500MB` });
        }
      }

      fileToUpload.value = validFiles;
    };

    const uploadFileLettureOnFtp = () => {
      submitted.value = true;

      if (validateForm()) {
        loading.value = true;

        caricamentoService.uploadFileLettureOnFtp(fileToUpload.value, 'POD')
          .then(() => {
            toast.add({ severity: "success", summary: "Successo", detail: "File caricati con successo", life: 5000 });
            fileToUpload.value = [];
            fetchUploadedFiles();
            fetchCurrentTypeLogs();
          })
          .catch(() => {
            toast.add({ severity: "error", summary: "Errore", detail: "Errore durante il caricamento file" });
          })
          .finally(() => {
            loading.value = false;
          });
      }
    };

    const uploadFileLettureOnFtpGas = () => {
      submitted.value = true;

      if (validateForm()) {
        loading.value = true;

        caricamentoService.uploadFileLettureOnFtpGas(fileToUpload.value, 'PDR')
          .then(() => {
            toast.add({ severity: "success", summary: "Successo", detail: "File caricati con successo", life: 5000 });
            fileToUpload.value = [];
            fetchUploadedFiles();
            fetchCurrentTypeLogs();
          })
          .catch(() => {
            toast.add({ severity: "error", summary: "Errore", detail: "Errore durante il caricamento file GAS" });
          })
          .finally(() => {
            loading.value = false;
          });
      }
    };

    const validateForm = () => {
      if (fileToUpload.value.length === 0) {
        validationErrors.value["files"] = true;
        delete validationErrors.value["type"];
      } else {
        delete validationErrors.value["files"];
      }

      if (fileToUpload.value.length > 0) {
        const valid = [...fileToUpload.value].every((file) => {
          const extension = file.name.split(".").pop().toLowerCase();
          return allowedType.value.includes(extension);
        });

        if (valid) {
          delete validationErrors.value["type"];
        } else {
          validationErrors.value["type"] = true;
        }
      }

      return !Object.keys(validationErrors.value).length;
    };

    const fetchUploadedFiles = async () => {
      console.log('fetchUploadedFiles called with selectedType:', selectedType.value);

      try {
        const filesResponse = await caricamentoService.getAllUploadedFilesLetture();
        const formattedFiles = filesResponse.map((file) => ({
          ...file,
          created_at: moment(file.created_at).format("YYYY-MM-DD HH:mm:ss"),
        }));

        uploadedFiles.value = formattedFiles.filter((file) => {
          const filenameUpper = file.file_name.toUpperCase();
          const fileType = (file.name_fornitore || '').toUpperCase();

          if (selectedType.value === 'EE') {
            return filenameUpper.includes('EE') || fileType.includes('POD');
          } else {
            return filenameUpper.includes('GAS') || fileType.includes('PDR');
          }
        });

        uploadedFilesCount.value = uploadedFiles.value.length;
        console.log('Filtered files:', uploadedFiles.value.length);
      } catch (error) {
        console.error('fetchUploadedFiles error:', error);
        toast.add({ severity: "error", summary: "Errore", detail: "Errore durante il recupero dei file" });
      }
    };

    const filteredFiles = computed(() => {
      return uploadedFiles.value.filter((file) =>
        file.file_name.toLowerCase().includes(searchQuery.value.toLowerCase())
      );
    });

    const fetchData = async () => {
      loading.value = true;
      error.value = null;

      console.log('fetchData called with selectedType:', selectedType.value);

      try {
        const formData = new FormData();
        formData.append("mesecomp", formattedMesecomp.value);
        formData.append("creationday", formattedCreationday.value);

        let typeForApi;

        if (selectedType.value === 'EE') {
          typeForApi = 'ele';
        } else if (selectedType.value === 'GAS') {
          typeForApi = 'gas';
        }

        formData.append("type", typeForApi);

        const endpoint = "https://flussi.askmanagement.it/api/getXmlCache";
        const response = await axios.post(endpoint, formData);

        distribuzioneData.value = response.data;
        console.log('Data received:', response.data);
      } catch (err) {
        console.error('fetchData error:', err);
        error.value = "Errore durante il recupero dei dati flussi.";
      } finally {
        loading.value = false;
      }
    };

    const filterData = () => {
      fetchData();
    };

    onMounted(() => {
      fetchUploadedFiles();
      fetchData();
      fetchCurrentTypeLogs();
    });

    watch([selectedMonth, selectedYear], () => {
      fetchData();
    });

    watch([currentPageLogs, perPageLogs], () => {
      fetchCurrentTypeLogs();
    });

    return {
      selectedType,
      toggleType,
      changeType,
      currentLogs,
      logsLoading,
      currentPageLogs,
      perPageLogs,
      totalLogs,
      onPageChangeLogs,
      distribuzioneData,
      error,
      months,
      years,
      weekdays,
      selectedMonth,
      selectedYear,
      selectedDay,
      showCalendar,
      filterData,
      firstDayOfMonth,
      daysInMonth,
      isToday,
      selectDay,
      formatSelectedDate,
      toggleCalendar,
      formattedMesecomp,
      formattedCreationday,
      validationErrors,
      submitted,
      fileToUpload,
      handleFileUpload,
      allowedType,
      acceptedFileTypes,
      uploadFileLettureOnFtp,
      uploadFileLettureOnFtpGas,
      validateForm,
      uploadedFiles,
      fetchUploadedFiles,
      searchQuery,
      filteredFiles,
      loading,
      processedFiles,
      isDragging,
      onDragOver,
      onDragLeave,
      onDrop,
      removeFile,
      formatFileSize,
      quantitaHeader,
      quantitaField,
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');


.lettura-view {
  font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lettura-view *,
.lettura-view *::before,
.lettura-view *::after {
  font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, sans-serif !important;
  box-sizing: border-box;
}

.lv-page-wrapper {
  width: 100%;
  padding: 1rem;
}

.lv-page-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
}

.lv-card-wrapper {
  width: 100%;
  margin: 1rem 0;
}

.lv-card {
  width: 100%;
}

.lv-card--wide {
  max-width: none;
}

.lv-title,
.lv-card-title {
  color: #30656e;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  text-align: center;
}

.lv-header {
  margin-bottom: 1.5rem;
}

.lv-filter-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.5rem;
  position: relative;
  z-index: 100;
}

.lv-date-selectors,
.lv-calendar-container {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.lv-selector-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.lv-date-inputs {
  display: flex;
  gap: 0.5rem;
}

.lv-selector-group label,
.lv-calendar-container label {
  font-weight: 600;
  color: #30656e;
  font-size: 0.9rem;
}

/* Form Elements */
.lv-select {
  padding: 0.5rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 6px;
  background: #fff;
  font-size: 0.9rem;
  min-width: 120px;
}

.lv-select--small {
  padding: 0.4rem 0.6rem;
  font-size: 0.85rem;
  min-width: 80px;
}

.lv-select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.lv-search-input {
  width: 100%;
  max-width: 300px;
  padding: 0.5rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 6px;
  margin-bottom: 1rem;
}

.lv-search-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.lv-select-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.lv-calendar-picker {
  position: relative;
  z-index: 101;
}

.lv-selected-date {
  padding: 0.5rem 0.75rem;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  min-width: 120px;
  text-align: center;
  transition: all 0.2s ease;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
}

.lv-selected-date:hover {
  border-color: #adb5bd;
  background-color: #f8f9fa;
}

.lv-calendar-popup {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  width: 280px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  z-index: 102;
  overflow: hidden;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.lv-calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #448c94 0%, #2c5e65 100%);
  color: #fff;
  padding: 0.8rem;
  font-weight: 600;
}

.lv-calendar-close {
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 1.1rem;
  transition: all 0.2s ease;
}

.lv-calendar-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

.lv-weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  background: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
}

.lv-weekday {
  padding: 0.6rem 0.4rem;
  font-weight: 600;
  font-size: 12px;
  color: #448c94;
}

.lv-calendar-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  background: #f8f9fa;
  padding: 0.6rem;
}

.lv-day {
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  font-size: 13px;
  transition: all 0.2s ease;
}

.lv-day:not(.lv-day--empty):hover {
  background: #e9ecef;
  transform: scale(1.1);
}

.lv-day--selected {
  background: linear-gradient(135deg, #448c94 0%, #2c5e65 100%);
  color: #fff;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.lv-day--today:not(.lv-day--selected) {
  font-weight: 600;
  position: relative;
}

.lv-day--empty {
  cursor: default;
}

.lv-date-display {
  background: linear-gradient(90deg, #f0f4f8 0%, #ffffff 100%);
  border-left: 4px solid #448c94;
  padding: 0.8rem 1.2rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  font-weight: 500;
  font-size: 16px;
  color: #30656e;
}

.lv-date-value,
.lv-type-indicator {
  font-weight: 700;
  color: #448c94;
}

.lv-type-indicator {
  font-size: 16px;
}

.lv-date-value {
  font-size: 17px;
}

.lv-table-section {
  position: relative;
  z-index: 1;
}

.lv-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.lv-table-head {
  background: #30656e;
}

.lv-table-th {
  background: #30656e;
  color: #fff;
  padding: 1rem 0.75rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.9rem;
  border: none;
}

.lv-table-body {
  background: #fff;
}

.lv-table-tr:nth-child(even) {
  background: #f8f9fa;
}

.lv-table-tr:hover {
  background: #e9ecef;
}

.lv-table-td {
  padding: 0.75rem;
  border-bottom: 1px solid #dee2e6;
  font-size: 0.9rem;
}


:deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th) {
  background: #495057 !important;
  color: #fff !important;
  border: none !important;
  padding: 1rem !important;
  font-weight: 600 !important;
  text-align: center !important;
  vertical-align: middle !important;
  font-family: 'Montserrat', sans-serif !important;
}

:deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th:hover) {
  background: #30656e !important;
  color: #fff !important;
  box-shadow: none !important;
}

:deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th.p-sortable-column:hover) {
  background: #30656e !important;
  color: #fff !important;
  box-shadow: none !important;
}

:deep(.lv-data-table.p-datatable .p-datatable-tbody > tr > td) {
  padding: 0.8rem 1rem !important;
  border-bottom: 1px solid #dee2e6 !important;
  font-size: 0.9rem !important;
  text-align: center !important;
  vertical-align: middle !important;
  font-family: 'Montserrat', sans-serif !important;
}

:deep(.lv-data-table.p-datatable .p-datatable-tbody > tr > td:first-child) {
  text-align: left !important;
  padding-left: 1.2rem !important;
  font-weight: 500 !important;
}

:deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th:first-child) {
  text-align: left !important;
  padding-left: 1.2rem !important;
}

:deep(.lv-data-table.p-datatable .p-datatable-tbody > tr:nth-child(even)) {
  background: #f8f9fa !important;
}

:deep(.lv-data-table.p-datatable .p-datatable-tbody > tr:hover) {
  background: #e9ecef !important;
}

:deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th .p-sortable-column-icon) {
  color: #fff !important;
  margin-left: 0.5rem !important;
  opacity: 1 !important;
  font-size: 0.9rem !important;
  display: inline-block !important;
  visibility: visible !important;
}

:deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th:hover .p-sortable-column-icon),
:deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th.p-sortable-column:hover .p-sortable-column-icon) {
  color: #fff !important;
  opacity: 1 !important;
  visibility: visible !important;
}

:deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th.p-sortable-column) {
  cursor: pointer !important;
  user-select: none !important;
}

:deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th.p-sortable-column .p-column-header-content) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

:deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th:first-child.p-sortable-column .p-column-header-content) {
  justify-content: flex-start !important;
}

:deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th .p-column-title) {
  color: #fff !important;
  font-weight: 600 !important;
}

:deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th:not(.p-sortable-column):hover),
:deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th.p-sortable-column:not(:hover)) {
  background: #495057 !important;
  color: #fff !important;
}

:deep(.lv-data-table .pi) {
  color: #fff !important;
}

:deep(.lv-data-table .pi-sort-alt),
:deep(.lv-data-table .pi-sort-up),
:deep(.lv-data-table .pi-sort-down) {
  color: #fff !important;
  opacity: 1 !important;
}

.lv-totale-row {
  font-weight: 700 !important;
  color: #495057 !important;
}

.lv-upload-zone {
  border: 2px dashed #007bff;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  background: #f8f9fa;
  position: relative;
  transition: all 0.3s ease;
}

.lv-upload-zone:hover {
  border-color: #0a2b4e;
  background: #e3f2fd;
}

.lv-upload-zone--dragover {
  border-color: #176028;
  background: #f0fff4;
  border-style: solid;
}

.lv-file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.lv-upload-icon {
  font-size: 3rem;
  color: #213f60;
  margin-bottom: 1rem;
}

.lv-upload-text {
  font-size: 1.1rem;
  color: #495057;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.lv-upload-subtext {
  font-size: 0.9rem;
  color: #6c757d;
  margin-bottom: 1rem;
}

.lv-file-list {
  margin-top: 1rem;
  text-align: left;
}

.lv-file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background: #e9ecef;
  border-radius: 6px;
  margin-bottom: 0.5rem;
}

.lv-file-name {
  font-weight: 500;
  color: #495057;
}

.lv-file-size {
  font-size: 0.8rem;
  color: #6c757d;
  margin-left: 0.5rem;
}

.lv-file-remove {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}

.lv-file-remove:hover {
  background: #dc3545;
  color: #fff;
}

.lv-button-group {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;
  flex-wrap: wrap;
}

.lv-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;
}

.lv-btn--primary {
  background: #007bff;
  color: #fff;
}

.lv-btn--primary:hover {
  background: #0056b3;
  transform: translateY(-1px);
}

.lv-btn--success {
  background: #28a745;
  color: #fff;
}

.lv-btn--success:hover {
  background: #1e7e34;
  transform: translateY(-1px);
}

.lv-btn--secondary {
  background: #30656e;
  color: #fff;
}

.lv-btn--secondary:hover {
  background: #545b62;
}

.lv-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.lv-switch-container {
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
  margin-bottom: 2rem;
}

.lv-switch-wrapper {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: #f8f9fa;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  border: 1px solid #dee2e6;
}

.lv-switch-label {
  font-weight: 600;
  font-size: 0.8rem;
  color: #6c757d;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.lv-switch-label--active {
  color: #284768;
}

.lv-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.lv-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.lv-switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #007bff;
  transition: 0.4s;
  border-radius: 24px;
}

.lv-switch-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #fff;
  transition: 0.4s;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.lv-switch input:checked+.lv-switch-slider {
  background: #28a745;
}

.lv-switch input:checked+.lv-switch-slider:before {
  transform: translateX(20px);
}

.lv-empty-state {
  text-align: center;
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px dashed #dee2e6;
  margin-top: 1rem;
}

.lv-empty-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.lv-empty-state h3 {
  color: #495057;
  margin-bottom: 0.5rem;
}

.lv-empty-state p {
  color: #6c757d;
}

.lv-error-alert {
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
  padding: 0.75rem;
  border-radius: 6px;
  margin-top: 1rem;
}

.lv-error-message {
  font-weight: 500;
}

.lv-error-text {
  color: #dc3545;
  font-size: 0.85rem;
  margin-top: 0.25rem;
}

.lv-loading {
  text-align: center;
  padding: 2rem;
  color: #6c757d;
  font-style: italic;
}

.lv-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  gap: 1rem;
}

.lv-pagination-info {
  font-size: 0.9rem;
  color: #6c757d;
  font-weight: 500;
}

@media (max-width: 768px) {
  .lv-page-wrapper {
    padding: 0.5rem;
  }

  .lv-page-container {
    padding: 1rem;
  }

  .lv-filter-section {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .lv-date-selectors,
  .lv-calendar-container {
    justify-content: center;
  }

  .lv-button-group {
    flex-direction: column;
    align-items: center;
  }

  .lv-btn {
    width: 100%;
    max-width: 250px;
  }

  .lv-pagination {
    flex-direction: column;
    gap: 0.5rem;
  }

  .lv-calendar-popup {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    width: 90vw !important;
    max-width: 280px !important;
    z-index: 1000 !important;
  }

  .lv-table {
    font-size: 0.8rem;
  }

  .lv-table-th,
  .lv-table-td {
    padding: 0.5rem 0.4rem;
  }
}

@media (max-width: 480px) {

  .lv-title,
  .lv-card-title {
    font-size: 1.25rem;
  }

  .lv-upload-zone {
    padding: 1.5rem;
  }

  .lv-upload-icon {
    font-size: 2.5rem;
  }

  .lv-search-input {
    max-width: none;
  }
}
</style>